import { render } from "./Formato2013.vue?vue&type=template&id=e1a28764&scoped=true"
import script from "./Formato2013.vue?vue&type=script&lang=js"
export * from "./Formato2013.vue?vue&type=script&lang=js"

import "./Formato2013.vue?vue&type=style&index=0&id=e1a28764&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a28764"]])

export default __exports__